export default "__VITE_ASSET__rm64XSSa__"